document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchDialog = searchOverlay ? searchOverlay.querySelector('.imh-search-overlay__dialog') : null;

  const searchInputs = document.querySelectorAll('[data-search-input]');
  const searchTriggers = document.querySelectorAll('.imh-search-trigger');
  const searchCloseButtons = document.querySelectorAll('[data-search-close]');

  const searchCardsTrack = document.querySelector('[data-search-cards]');
  const searchCardsPrev = document.querySelector('[data-search-cards-prev]');
  const searchCardsNext = document.querySelector('[data-search-cards-next]');

  const searchFallback = document.querySelector('[data-search-fallback]');
  const searchPredictive = document.querySelector('[data-search-predictive]');
  const searchEmpty = document.querySelector('[data-search-empty]');
  const predictiveSuggestions = document.querySelector('[data-predictive-suggestions]');
  const predictiveProducts = document.querySelector('[data-predictive-products]');
  const predictiveViewAll = document.querySelector('[data-predictive-view-all]');

  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerOpenButton = document.querySelector('[data-drawer-open]');
  const drawerCloseButton = document.querySelector('[data-drawer-close]');

  const megaTriggers = document.querySelectorAll('[data-mega-trigger]');
  const simpleDropdownTriggers = document.querySelectorAll('[data-simple-dropdown-trigger]');

  let lastSearchTrigger = null;
  let ignoreNextDocumentClick = false;
  let lastOverlayOpenAt = 0;
  let predictiveAbortController = null;
  let predictiveDebounce = null;
  const predictiveCache = {};
function setOverlayPosition(trigger) {
  if (!searchOverlay || !searchDialog || !trigger) return;

  const rect = trigger.getBoundingClientRect();
  const isMobile = window.innerWidth <= 989;

  if (isMobile) {
    const mobileWidth = Math.min(
      rect.width,
      window.innerWidth - 20
    );

    searchOverlay.style.setProperty(
      '--imh-overlay-width',
      `${mobileWidth}px`
    );

    searchOverlay.style.setProperty(
      '--imh-overlay-left',
      `${window.innerWidth / 2}px`
    );

    searchOverlay.style.setProperty(
      '--imh-overlay-top',
      `${rect.bottom + 6}px`
    );

    return;
  }

  /*
   * Desktop overlay:
   * Wider than the search input and aligned to its right edge.
   */
  const viewportPadding = 16;
  const preferredWidth = 720;

  const availableWidth =
    window.innerWidth - viewportPadding * 2;

  const overlayWidth = Math.min(
    preferredWidth,
    availableWidth
  );

  /*
   * Keep the dropdown's right edge aligned with the search field.
   */
  let rightEdge = Math.min(
    rect.right,
    window.innerWidth - viewportPadding
  );

  let leftEdge = rightEdge - overlayWidth;

  /*
   * Prevent dropdown from crossing the left viewport edge.
   */
  if (leftEdge < viewportPadding) {
    leftEdge = viewportPadding;
    rightEdge = leftEdge + overlayWidth;
  }

  const actualWidth = rightEdge - leftEdge;
  const centerX = leftEdge + actualWidth / 2;

  searchOverlay.style.setProperty(
    '--imh-overlay-width',
    `${actualWidth}px`
  );

  searchOverlay.style.setProperty(
    '--imh-overlay-left',
    `${centerX}px`
  );

  searchOverlay.style.setProperty(
    '--imh-overlay-top',
    `${rect.bottom + 6}px`
  );
}

  function getSearchCardsStep() {
    if (!searchCardsTrack) return 300;

    const firstCard = searchCardsTrack.querySelector('.imh-search-card');
    if (!firstCard) return 300;

    const trackStyles = window.getComputedStyle(searchCardsTrack);
    const gap = parseInt(trackStyles.columnGap || trackStyles.gap || 10, 10);

    return firstCard.getBoundingClientRect().width + gap;
  }

  function updateSearchCardsNav() {
    if (!searchCardsTrack || !searchCardsPrev || !searchCardsNext) return;

    const maxScroll = searchCardsTrack.scrollWidth - searchCardsTrack.clientWidth;
    const currentScroll = searchCardsTrack.scrollLeft;

    searchCardsPrev.disabled = currentScroll <= 4;
    searchCardsNext.disabled = currentScroll >= maxScroll - 4;
  }

 function scrollSearchCards(direction) {
  if (!searchCardsTrack) return;

  const step = getSearchCardsStep();
  const cardsPerClick = window.innerWidth > 989 ? 3 : 1;

  searchCardsTrack.scrollBy({
    left: direction * step * cardsPerClick,
    behavior: 'smooth'
  });

  window.setTimeout(updateSearchCardsNav, 350);
}

  function syncSearchInputs(value, skipInput = null) {
    searchInputs.forEach((input) => {
      if (input !== skipInput) {
        input.value = value;
      }
    });
  }

  function showFallback() {
    if (searchFallback) searchFallback.hidden = false;
    if (searchPredictive) searchPredictive.hidden = true;
    if (searchEmpty) searchEmpty.hidden = true;

    window.setTimeout(() => {
      updateSearchCardsNav();
    }, 80);
  }

  function showPredictive() {
    if (searchFallback) searchFallback.hidden = true;
    if (searchPredictive) searchPredictive.hidden = false;
    if (searchEmpty) searchEmpty.hidden = true;
  }

  function showEmpty() {
    if (searchFallback) searchFallback.hidden = true;
    if (searchPredictive) searchPredictive.hidden = true;
    if (searchEmpty) searchEmpty.hidden = false;
  }

  function openSearch(trigger = null) {
    if (!searchOverlay) return;

    lastSearchTrigger = trigger || document.querySelector('.imh-search-trigger');
    setOverlayPosition(lastSearchTrigger);

    if (!searchOverlay.hidden) return;

    ignoreNextDocumentClick = true;
    lastOverlayOpenAt = Date.now();
    searchOverlay.hidden = false;
    const inputToFocus =
  trigger && trigger.querySelector('[data-search-input]')
    ? trigger.querySelector('[data-search-input]')
    : document.activeElement && document.activeElement.matches('[data-search-input]')
      ? document.activeElement
      : null;

if (inputToFocus) {
  setTimeout(() => {
    inputToFocus.focus({ preventScroll: true });

    const valueLength = inputToFocus.value.length;
    inputToFocus.setSelectionRange(valueLength, valueLength);
  }, 80);
}

    window.setTimeout(() => {
      ignoreNextDocumentClick = false;
    }, 220);

    const activeInput =
      document.activeElement && document.activeElement.matches('[data-search-input]')
        ? document.activeElement
        : searchInputs[0];

    const currentValue = activeInput ? activeInput.value.trim() : '';

    if (currentValue) {
      fetchPredictiveResults(currentValue);
    } else {
      showFallback();
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    if (drawerOpenButton) drawerOpenButton.setAttribute('aria-expanded', 'true');
    body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    if (drawerOpenButton) drawerOpenButton.setAttribute('aria-expanded', 'false');
    body.classList.remove('overflow-hidden');
  }

  function escapeHtml(str = '') {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

function formatMoneyValue(amount) {
  const value = Number(amount || 0);

  if (Number.isNaN(value)) return '';

  return `₹${value.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })}`;
}

  function buildSuggestionMarkup(queries = [], collections = []) {
    const items = [];

    queries.forEach((query) => {
      items.push(`
        <a href="${query.url}" class="imh-predictive__suggestion-item">
          ${escapeHtml(query.text || '')}
        </a>
      `);
    });

    collections.forEach((collection) => {
      items.push(`
        <a href="${collection.url}" class="imh-predictive__suggestion-item">
          ${escapeHtml(collection.title || '')}
        </a>
      `);
    });

    return items.join('');
  }

  function formatMoneyValue(amount) {
  const value = Number(amount || 0);

  if (Number.isNaN(value) || value <= 0) return '';

  return `₹${value.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })}`;
}

function getProductPrice(product) {
  return Number(
    product.price ||
    product.price_min ||
    product.min_price ||
    0
  );
}

function getProductCompareAtPrice(product) {
  return Number(
    product.compare_at_price ||
    product.compare_at_price_min ||
    product.compare_at_price_max ||
    product.max_compare_at_price ||
    0
  );
}

function getDiscountPercent(price, compareAtPrice) {
  if (!price || !compareAtPrice || compareAtPrice <= price) return 0;
  return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
}

function buildProductMarkup(products = []) {
  return products
    .map((product) => {
      const imageUrl = product.featured_image ? `${product.featured_image.url}&width=400` : '';
      const imageAlt = product.featured_image?.alt || product.title || '';

      const priceValue = getProductPrice(product);
      const compareAtValue = getProductCompareAtPrice(product);
      const discountPercent = getDiscountPercent(priceValue, compareAtValue);

      const compareAt =
        compareAtValue > priceValue
          ? `<span class="imh-predictive__product-compare-price">${formatMoneyValue(compareAtValue)}</span>`
          : '';

      const price =
        priceValue > 0
          ? `<span class="imh-predictive__product-price">${formatMoneyValue(priceValue)}</span>`
          : '';

      const discountBadge =
        discountPercent > 0
          ? `<span class="imh-predictive__product-discount-badge">${discountPercent}%OFF</span>`
          : '';

      return `
        <a href="${product.url}" class="imh-predictive__product-item">
          <div class="imh-predictive__product-image-wrap">
            ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(imageAlt)}" class="imh-predictive__product-image">` : ''}
          </div>
          <div class="imh-predictive__product-content">
            <div class="imh-predictive__product-title">${escapeHtml(product.title || '')}</div>
            <div class="imh-predictive__product-prices">
              ${price}
              ${compareAt}
              ${discountBadge}
            </div>
          </div>
        </a>
      `;
    })
    .join('');
}

  async function fetchPredictiveResults(query) {
    const trimmedQuery = query.trim();

    if (!trimmedQuery) {
      showFallback();
      return;
    }

    const cacheKey = trimmedQuery.toLowerCase();

    if (predictiveCache[cacheKey]) {
      renderPredictiveResults(predictiveCache[cacheKey], trimmedQuery);
      return;
    }

    if (predictiveAbortController) {
      predictiveAbortController.abort();
    }

    predictiveAbortController = new AbortController();

    const params = new URLSearchParams({
      q: trimmedQuery,
      'resources[type]': 'product,collection,query',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'hide',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
    });

    try {
      const response = await fetch(`/search/suggest.json?${params.toString()}`, {
        signal: predictiveAbortController.signal,
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) throw new Error('Predictive search request failed');

      const data = await response.json();
      const resources = data.resources?.results || {};

      const parsed = {
        queries: resources.queries || [],
        collections: resources.collections || [],
        products: (resources.products || []).slice(0, 6),
        viewAllUrl: `/search?q=${encodeURIComponent(trimmedQuery)}&options%5Bprefix%5D=last`
      };

      predictiveCache[cacheKey] = parsed;
      renderPredictiveResults(parsed, trimmedQuery);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error(error);
      showEmpty();
    }
  }

  function renderPredictiveResults(data, query) {
    if (!predictiveSuggestions || !predictiveProducts || !predictiveViewAll) return;

    const hasSuggestions =
      (data.queries && data.queries.length) || (data.collections && data.collections.length);
    const hasProducts = data.products && data.products.length;

    if (!hasSuggestions && !hasProducts) {
      showEmpty();
      predictiveViewAll.href = `/search?q=${encodeURIComponent(query || '')}&options%5Bprefix%5D=last`;
      predictiveViewAll.textContent = 'VIEW ALL';
      return;
    }

    predictiveSuggestions.innerHTML = buildSuggestionMarkup(data.queries || [], data.collections || []);
    predictiveProducts.innerHTML = buildProductMarkup(data.products || []);
    predictiveViewAll.href = data.viewAllUrl || '#';

    const totalCount =
      (data.queries?.length || 0) +
      (data.collections?.length || 0) +
      (data.products?.length || 0);

    predictiveViewAll.textContent = totalCount ? `VIEW ALL (${totalCount})` : 'VIEW ALL';

    showPredictive();
  }

  function handleSearchInput(input) {
    const value = input.value;
    syncSearchInputs(value, input);

    if (!searchOverlay.hidden) {
      if (value.trim()) {
        if (predictiveDebounce) clearTimeout(predictiveDebounce);
        predictiveDebounce = setTimeout(() => {
          fetchPredictiveResults(value);
        }, 180);
      } else {
        showFallback();
      }
    }
  }

  searchInputs.forEach((input) => {
    input.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
      openSearch(input.closest('.imh-search-trigger'));
    });

    input.addEventListener('focus', () => {
      openSearch(input.closest('.imh-search-trigger'));
    });

    input.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    input.addEventListener('input', () => {
      handleSearchInput(input);
    });
  });

  searchTriggers.forEach((trigger) => {
    trigger.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
      openSearch(trigger);
    });

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  searchCloseButtons.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      closeSearch();
    });
  });

  if (searchCardsPrev) {
    searchCardsPrev.addEventListener('click', (event) => {
      event.stopPropagation();
      scrollSearchCards(-1);
    });
  }

  if (searchCardsNext) {
    searchCardsNext.addEventListener('click', (event) => {
      event.stopPropagation();
      scrollSearchCards(1);
    });
  }

  if (searchCardsTrack) {
    searchCardsTrack.addEventListener(
      'scroll',
      () => {
        updateSearchCardsNav();
      },
      { passive: true }
    );

    searchCardsTrack.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
          event.preventDefault();
          searchCardsTrack.scrollLeft += event.deltaY;
        }
      },
      { passive: false }
    );

    window.setTimeout(updateSearchCardsNav, 100);
  }

  if (drawerOpenButton) {
    drawerOpenButton.addEventListener('click', openDrawer);
  }

  if (drawerCloseButton) {
    drawerCloseButton.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSearch();
      closeDrawer();

      document.querySelectorAll('.imh-nav__item.is-open').forEach((item) => {
        item.classList.remove('is-open');
        const btn = item.querySelector('.imh-nav__button');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  window.addEventListener('resize', () => {
    if (!searchOverlay || searchOverlay.hidden || !lastSearchTrigger) return;
    setOverlayPosition(lastSearchTrigger);
    updateSearchCardsNav();
  });

  window.addEventListener('scroll', () => {
    if (!searchOverlay || searchOverlay.hidden || !lastSearchTrigger) return;
    setOverlayPosition(lastSearchTrigger);
  });

  if (window.innerWidth > 989) {
    document.querySelectorAll('.imh-nav__item.has-mega, .imh-nav__item.has-children').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        item.classList.add('is-open');
        const btn = item.querySelector('.imh-nav__button');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-open');
        const btn = item.querySelector('.imh-nav__button');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    });
  } else {
    megaTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const item = event.currentTarget.closest('.imh-nav__item');
        if (!item) return;

        const isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.imh-nav__item.is-open').forEach((openItem) => {
          openItem.classList.remove('is-open');
          const btn = openItem.querySelector('.imh-nav__button');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          event.currentTarget.setAttribute('aria-expanded', 'true');
        }
      });
    });

    simpleDropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const item = event.currentTarget.closest('.imh-nav__item');
        if (!item) return;

        const isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.imh-nav__item.is-open').forEach((openItem) => {
          openItem.classList.remove('is-open');
          const btn = openItem.querySelector('.imh-nav__button');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('is-open');
          event.currentTarget.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.querySelectorAll('[data-mobile-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.imh-mobile-accordion');
      if (!item) return;

      const isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.imh-mobile-accordion').forEach((accordion) => {
        accordion.classList.remove('is-open');
        const btn = accordion.querySelector('[data-mobile-accordion-trigger]');
        const icon = accordion.querySelector('.imh-mobile-accordion__icon');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (icon) icon.textContent = '+';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        const icon = item.querySelector('.imh-mobile-accordion__icon');
        if (icon) icon.textContent = '−';
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (ignoreNextDocumentClick) return;
    if (Date.now() - lastOverlayOpenAt < 250) return;

    const insideNav = event.target.closest('.imh-nav__item');
    const insideSearch = event.target.closest('.imh-search-overlay__dialog');
    const insideSearchTrigger = event.target.closest('.imh-search-trigger');

    if (!insideNav) {
      document.querySelectorAll('.imh-nav__item.is-open').forEach((item) => {
        item.classList.remove('is-open');
        const btn = item.querySelector('.imh-nav__button');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    if (searchOverlay && !searchOverlay.hidden && !insideSearch && !insideSearchTrigger) {
      closeSearch();
    }
  });

  const typingNodes = document.querySelectorAll('[data-typing-placeholder]');

  typingNodes.forEach((node) => {
    let texts = [];
    try {
      texts = JSON.parse(node.getAttribute('data-texts') || '[]').filter(Boolean);
    } catch (e) {
      texts = [];
    }

    if (!texts.length) return;

    const speed = parseInt(node.getAttribute('data-speed'), 10) || 90;
    let textIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function setTypedValue(el, value) {
      if (document.activeElement === el) return;

      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.setAttribute('placeholder', value);
      } else {
        el.textContent = value;
      }
    }

    function typeLoop() {
      const currentText = texts[textIndex] || '';
      let displayedText = '';

      if (isDeleting) {
        charIndex = Math.max(charIndex - 1, 0);
        displayedText = currentText.substring(0, charIndex);
      } else {
        charIndex = Math.min(charIndex + 1, currentText.length);
        displayedText = currentText.substring(0, charIndex);
      }

      setTypedValue(node, displayedText);

      let timeout = speed;

      if (!isDeleting && charIndex === currentText.length) {
        timeout = 1200;
        isDeleting = true;
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        textIndex = (textIndex + 1) % texts.length;
        timeout = 350;
      } else {
        timeout = isDeleting ? Math.max(35, speed / 2) : speed;
      }

      window.setTimeout(typeLoop, timeout);
    }

    setTypedValue(node, '');
    window.setTimeout(typeLoop, 500);
  });
});


